// extracted by mini-css-extract-plugin
module.exports = {"tag":"_3vKm9","placeholder":"JwmLF","listItem":"_1WzN","link":"jmdHf"};